import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    defaultMessage:
      'There are risks involved with staking your assets. To learn more follow me {here}!',
  },
  here: { defaultMessage: 'here' },
});
